/**
 * @description 判读是否为外链
 * @param string value
 * @returns {boolean}
 */
export function isExternal(value) {
  return /^(https?:|mailto:|tel:)/.test(value);
}

/**
 * @description 判断是否为数字
 * @param string value
 * @returns {boolean}
 */
export function isNumber(value) {
  const reg = /^[0-9]*$/;
  return reg.test(value);
}

/**
 * @description 判断是否是名称
 * @param string value
 * @returns {boolean}
 */
export function isName(value) {
  if (value === '' || value === undefined || value === null) {
    return false;
  } else {
    const reg = /^[\u4e00-\u9fa5a-zA-Z0-9]+$/
    return reg.test(value)
  }
}

/**
 * @description 判断是否为IP
 * @param string value
 * @returns {boolean}
 */
export function isIP(value) {
  const reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
  return reg.test(value);
}

/**
 * @description 判断是否是传统网站
 * @param string value
 * @returns {boolean}
 */
export function isUrl(value) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return reg.test(value);
}

/**
 * @description 判断是否是小写字母
 * @param string value
 * @returns {boolean}
 */
export function isLowerCase(value) {
  const reg = /^[a-z]+$/;
  return reg.test(value);
}

/**
 * @description 判断是否是大写字母
 * @param string value
 * @returns {boolean}
 */
export function isUpperCase(value) {
  const reg = /^[A-Z]+$/;
  return reg.test(value);
}

/**
 * @description 判断是否是大写字母开头
 * @param string value
 * @returns {boolean}
 */
export function isAlphabets(value) {
  const reg = /^[A-Za-z]+$/;
  return reg.test(value);
}

/**
 * @description 判断是否是字符串
 * @param string value
 * @returns {boolean}
 */
export function isString(value) {
  return typeof value === "string" || value instanceof String;
}

/**
 * @description 判断是否是数组
 * @param array value
 * @returns {arg is any[]|boolean}
 */
export function isArray(value) {
  if (typeof Array.isArray === "undefined") {
    return Object.prototype.toString.call(value) === "[object Array]";
  }
  return Array.isArray(value);
}

/**
 * @description 判断是否是端口号
 * @param string value
 * @returns {boolean}
 */
export function isPort(value) {
  const reg = /^([0-9]|[1-9]\d|[1-9]\d{2}|[1-9]\d{3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/;
  return reg.test(value);
}

/**
 * @description 判断是否是身份证号(第二代)
 * @param string value
 * @returns {boolean}
 */
export function isIdCard(value) {
  const reg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
  return reg.test(value);
}

/**
 * @description 判断是否为空
 * @param string value
 * @returns {boolean}
 */
export function isBlank(value) {
  return (
    value == null ||
    false ||
    value === "" ||
    value.trim() === "" ||
    value.toLocaleLowerCase().trim() === "null"
  );
}

/**
 * @description 判断是否为固话
 * @param string value
 * @returns {boolean}
 */
export function isTelphone(value) {
  const reg = /^(400|800)([0-9\\-]{7,10})|(([0-9]{4}|[0-9]{3})(-| )?)?([0-9]{7,8})((-| |转)*([0-9]{1,4}))?$/;
  return reg.test(value);
}

/**
 * @description 判断经度 -180.0～+180.0（整数部分为0～180，必须输入1到5位小数）
 * @param string value
 * @returns {boolean}
 */
export function isLongitude(value) {
  const reg = /^[-|+]?(0?\d{1,2}\.\d{1,5}|1[0-7]?\d{1}\.\d{1,5}|180\.0{1,5})$/;
  return reg.test(value);
}

/**
 * @description 判断纬度 -90.0～+90.0（整数部分为0～90，必须输入1到5位小数）
 * @param string value
 * @returns {boolean}
 */
export function isLatitude(value) {
  const reg = /^[-|+]?([0-8]?\d{1}\.\d{1,5}|90\.0{1,5})$/;
  return reg.test(value);
}

/**
 * @description rtsp校验，只要有rtsp://
 * @param string value
 * @returns {boolean}
 */
export function isRTSP(value) {
  const reg = /^rtsp:\/\/([a-z]{0,10}:.{0,10}@)?(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
  const reg1 = /^rtsp:\/\/([a-z]{0,10}:.{0,10}@)?(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5]):[0-9]{1,5}/;
  const reg2 = /^rtsp:\/\/([a-z]{0,10}:.{0,10}@)?(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\//;
  return reg.test(value) || reg1.test(value) || reg2.test(value);
}

/**
 * @description 判断是否为数字且最多两位小数
 * @param string value
 * @returns {boolean}
 */
export function isFloat(value) {
  const reg = /^\d+(\.\d{1,2})?$/;
  return reg.test(value);
}


/**
 * @description 判断是否为数字且最多两位小数
 * @param string value
 * @returns {Boolean}
 */
export function isNumberFloat(value, min = 5, max = 10) {
  if (value === '' || value === undefined || value === null) {
    return '只能为数值';
  } else {
    const reg = /^\d+(\.\d{1,2})?$/
    const result = reg.test(value)
    if (result !== true) {
      return '只能为数值且最多两位小数';
    }
    return result
  }
}

/**
 * @description 是否为车牌号码
 * @param string value
 * @returns {Boolean}
 */
export function isPlateNumber(value, min = 5, max = 10) {
  if (value === '' || value === undefined || value === null) {
    return '车牌号不能为空';
  } else if ((value.length < min) || (value.length > max)) {
    return '车牌号格式错误'
  } else {
    const reg = /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/
    const result = reg.test(value)
    if (result !== true) {
      return '车牌号格式错误';
    }
    return result
  }
}

/**
 * @description 用户名：下划线、字母、数字
 * @param string value
 * @returns {Boolean}
 */
export function isUserName(value, min = 0, max = 100) {
  if (value === '' || value === undefined || value === null) {
    return '用户名不能为空'
  } else if ((value.length < min) || (value.length > max)) {
    return '用户名长度应在'+ min +'~'+ max +'字符之间'
  } else {
    const reg = /^[_a-zA-Z0-9]+$/
    const result = reg.test(value)
    if (result !== true) {
      return '用户名仅支持字母、数字或下划线'
    }
    return result
  }
}

/**
 * @description 登录密码：下划线、字母、数字
 * @param string value
 * @returns {Boolean}
 */
export function isPassword(value, min = 0, max = 100) {
  if (value === '' || value === undefined || value === null) {
    return '密码不能为空'
  } else if ((value.length < min) || (value.length > max)) {
    return '密码长度应在'+ min +'~'+ max +'字符之间'
  } else {
    const reg = /^[_a-zA-Z0-9]+$/
    const result = reg.test(value)
    if (result !== true) {
      return '密码仅支持字母、数字或下划线'
    }
    return result
  }
}

/**
 * @description 判断是否中文
 * @param string value
 * @returns {boolean}
 */
export function isNickName(value, min = 0, max = 100) {
  if (value === '' || value === undefined || value === null) {
    return '姓名不能为空'
  } else if ((value.length < min) || (value.length > max)) {
    return '姓名长度应在'+ min +'~'+ max +'字符之间'
  } else {
    const reg = /^[\u4E00-\u9FA5]+$/
    const result = reg.test(value)
    if (result !== true) {
      return '姓名仅支持中文字符'
    }
    return result
  }
}

/**
 * @description 判断是否中文
 * @param string value
 * @returns {boolean}
 */
export function isSupplierName(value, min = 0, max = 100) {
  if (value === '' || value === undefined || value === null) {
    return '供应商名称不能为空'
  } else if ((value.length < min) || (value.length > max)) {
    return '供应商名称长度应在'+ min +'~'+ max +'字符之间'
  } else {
    // const reg = /^[\u4E00-\u9FA5]+$/
    // const result = reg.test(value)
    // if (result !== true) {
    //   return '供应商名称仅支持中文字符'
    // }
    return true
  }
}

/**
 * @description 判断是否中文
 * @param string value
 * @returns {boolean}
 */
export function isChinese(value, min = 0, max = 100) {
  if (value === '' || value === undefined || value === null) {
    return '名称不能为空'
  } else if ((value.length < min) || (value.length > max)) {
    return '名称长度应在'+ min +'~'+ max +'字符之间'
  } else {
    const reg = /^[\u4E00-\u9FA5]+$/
    const result = reg.test(value)
    if (result !== true) {
      return '名称仅支持中文字符'
    }
    return result
  }
}

/**
 * @description 是否为手机号码或固定电话
 * @param string value
 * @returns {Boolean}
 */
export function isPhone(value, min = 11, max = 11) {
  if (value === '' || value === undefined || value === null) {
    return '手机号码不能为空';
  } else if ((value.length < min) || (value.length > max)) {
    return '手机号码应为11位'
  } else {
    const reg = /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/
    const result = reg.test(value)
    if (result !== true) {
      return '手机号码格式错误';
    }
    return result
  }
}

/**
 * @description 是否为电子邮箱
 * @param string value
 * @returns {boolean}
 */
export function isEmail(value, min = 0, max = 30) {
  if (value === '' || value === undefined || value === null) {
    return true
    // return '邮箱不能为空';
  } else if ((value.length < min) || (value.length > max)) {
    return '邮箱长度应在'+ min +'~'+ max +'字符之间';
  } else {
    const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
    const result = reg.test(value)
    if (result !== true) {
      return '邮箱格式错误';
    }
    return result
  }
}
